import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M19.5 14.252v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.127v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.621 9.879a3 3 0 0 0-5.02 2.898l.164.608a4.5 4.5 0 0 1-.108 2.676l-.157.44.44-.22a2.86 2.86 0 0 1 2.185-.156c.72.24 1.507.184 2.186-.155l.44-.22m-6.751-2.25H12m-1.5-13.5H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .622.504 1.125 1.125 1.125h12.75c.621 0 1.125-.503 1.125-1.125v-9.375a9 9 0 0 0-9-9"
    }, null, -1)
  ])))
}
export default { render: render }